import theme from 'assets/theme/theme';

const styles = () => ({
    headerHeight: {
        height: '36px'
    },
    formControlMode: {
        marginLeft: '5px',
        minWidth: '120px'
    },
    header: {
        display: 'flex',
        margin: '10px 10px 5px 10px'
    },
    isActiveSwitch: {
        marginLeft: '10px',
    }, leftIcon: {
        fontSize: 20,
        marginRight: '4px'
    },
    loaderContainer: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%'
    },
    paper: {
        height: 'calc(100% - 110px)',
        marginLeft: '10px',
        overflowX: 'auto',
        width: 'calc(100% - 20px)'
    },
    root: {
        height: '100%',
        overflow: 'auto',
        width: '100%'
    },
    searchBar: {
        margin: '0px 0px 0px 5px',
        flexGrow: 1,
    },
    searchIcon: {
        color: theme.palette.common.grey
    },
    table: {
        minWidth: 650
    },
    tableHeadCell: {
        backgroundColor: theme.palette.white.main
    },
});

export default styles;
